import { Unit, UnitBaseTypes } from "../../Units";

function PoundPerSquaredInch() {
  return (
    <>
      <Unit unit={UnitBaseTypes.psi} />
    </>
  );
}

export default PoundPerSquaredInch;
